/**
 * "Novidades" do menu da conta — o que entrou nesta versão (trilha T5a).
 *
 * A versão é a do `package.json` e a do topo do `CHANGELOG.md`, e um teste
 * confere que as três não se separam: é por este número que se sabe o que está
 * rodando em produção, então ele sobe a cada publicação (regra de 21/09/2026).
 * Só entra o que existe e funciona: novidade anunciada que não abre é promessa,
 * não novidade. Sem data de publicação: não há publicação datada para dizer, e
 * data inventada seria o primeiro dado falso da tela.
 *
 * A lista é a da versão CORRENTE. O histórico inteiro mora no `CHANGELOG.md`;
 * repeti-lo aqui faria a tela anunciar como nova uma coisa de meses atrás.
 */

export const VERSAO_DO_PRODUTO = '1.10.1';

export interface Novidade {
    titulo: string;
    descricao: string;
}

export const NOVIDADES: Novidade[] = [
    { titulo: 'Enter envia a mensagem', descricao: 'No chat, Enter envia a resposta e Shift+Enter quebra a linha, como no WhatsApp Web. Com a lista de mensagens rápidas aberta, Enter usa a primeira.' },
    { titulo: 'Emita a nota fiscal pelo sistema', descricao: 'Em Financeiro › Notas fiscais › Dados fiscais, envie o certificado e use Ligar ao emissor. A partir daí, Emitir nota manda a nota para a prefeitura, e a resposta aparece sozinha na tela.' },
    { titulo: 'PDF, XML e link da prefeitura', descricao: 'A nota autorizada traz o PDF, o XML e o link para conferir na prefeitura. Em produção, o paciente recebe a nota por e-mail.' },
    { titulo: 'Nota recusada se corrige e sai de novo', descricao: 'Quando a prefeitura recusa, a tela mostra o motivo. Corrija o cadastro, use Reler cadastros e Emitir de novo, com o mesmo número.' },
    { titulo: 'Cancelar nota com motivo', descricao: 'A nota autorizada tem o botão Cancelar nota. O motivo vai para a prefeitura e, se ela recusar, a tela diz por quê.' },
    { titulo: 'Nota automática ao receber', descricao: 'Ligue a opção nos Dados fiscais e o título recebido ganha a nota sozinho. Se faltar algum dado, ela fica em rascunho com o que falta.' },
    { titulo: 'Padrão nacional e reforma tributária', descricao: 'Cidades no padrão nacional pedem o código de tributação nacional. Os códigos de NBS e IBS/CBS também podem ser preenchidos com o contador.' },
];
